import { __assign } from "tslib";
import React from 'react';
import { Text } from '@keen.io/ui-core';
import { Header, Container, Value, Point, SizeContainer, } from './correlation.styles';
var Correlation = function (_a) {
    var title = _a.title, correlations = _a.correlations, color = _a.color, typography = _a.typography, _b = _a.valueKey, valueKey = _b === void 0 ? '' : _b;
    var size = correlations.find(function (_a) {
        var name = _a.name;
        return name === valueKey;
    });
    var labels = correlations
        .filter(function (_a) {
        var name = _a.name;
        return name !== valueKey;
    })
        .map(function (_a, idx) {
        var name = _a.name, value = _a.value;
        return (React.createElement(Container, { key: name + "-" + idx },
            React.createElement("div", null, name),
            React.createElement(Value, null, value)));
    });
    return (React.createElement(Text, __assign({}, typography),
        React.createElement(Header, null,
            React.createElement(Point, { color: color }),
            title),
        labels,
        size && (React.createElement(SizeContainer, { key: size.name },
            React.createElement("div", null, size.name),
            React.createElement(Value, null, size.value)))));
};
export default Correlation;
